import EventEmitter from 'events'

export default class Speaker extends EventEmitter {

	static instance

	constructor() {

		if ( Speaker.instance ) return Speaker.instance
		super()
		console.log( "INITIALIZE SPEAKER" )
		Speaker.instance = this

	}

}
